import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import store from '../../../store/store';
import Router from '@/Router';
import { CacheService } from "../services/CacheService";
import { ComparativoSalarial } from "@/interfaces/InterfaceComparativoSalarial";

class IndicadoresController {
  public static redirectToIndicadoresFiltered() {
    Router.push({ path: '/indicadoresAcidentes'});
  }

  public static redirectToTotalEpisEntreguesFiltered() {
    Router.push({ path: '/indicadoresEpis'});
  }

  public static redirectToTotalReunioesFiltered() {
    Router.push({ path: '/indicadoresReunioes'});
  }  

  public static redirectToTotalAfastamentosCIDFiltered() {
    Router.push({ path: '/indicadoresAfastamentos'});
  } 
  
  public static redirectToVariacaoSalarialFiltered() {
    if(!store.getters.user.dp){
      const errorMessage = 'A visualização deste indicador é exclusiva para Administradores.';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);
      return;
    }
    Router.push({ path: '/indicadoresVariacaoSalarial'});
  }

  public static async getTotalAcidentes(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg        = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAcidentes';

    const params = {
      requestType     : 'FilterData',
      NRORG           :           nrOrg,
      DTMESCOMPETENC  : dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Acidentes (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAcidentesGerenOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAcidentesGerenOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Acidentes (Estrutura Geral x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAcidentesOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAcidentesOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Acidentes (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAcidentesPorGravidadeLegalOcupacao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAcidentesPorGravidadeLegalOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Acidentes Por Gravidade (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAcidentesPorGravidadeGerenOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAcidentesPorGravidadeGerenOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Acidentes Por Gravidade (Estrutura Geral x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAcidentesPorGravidadeOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAcidentesPorGravidadeOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Acidentes Por Gravidade (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getQuantidadeDiasAfastadosLegalOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getQuantidadeDiasAfastadosLegalOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar as Quantidades de dias afastados (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getQuantidadeDiasAfastadosOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getQuantidadeDiasAfastadosOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar as Quantidades de dias afastados (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalPartesDoCorpoAtingidasLegalOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalPartesDoCorpoAtingidasLegalOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Partes do Corpo Atingidas (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalPartesDoCorpoAtingidasOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalPartesDoCorpoAtingidasOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Partes do Corpo Atingidas (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }


  public static async getSituacaoGeradoraAcidenteLegalOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getSituacaoGeradoraAcidenteLegalOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais das Situações Geradora Acidente (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getSituacaoGeradoraAcidenteOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getSituacaoGeradoraAcidenteOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais das Situações Geradora Acidente (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTiposHierarquia(
    showLoading = true,
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const route = 'getTiposHierarquia';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const tiposHierarquia: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return tiposHierarquia;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os tipos de hierarquia!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesLegalOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesLegalOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues  (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesGerenOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesGerenOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesVencidoLegalOcupacao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesVencidoLegalOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues com validade vencida (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesVencidoGerenOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesVencidoGerenOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues com validade vencida (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesVencidoOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesVencidoOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues com validade vencida (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesCAVencidoLegalOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesCAVencidoLegalOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues com CA vencido (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesCAVencidoGerenOcup(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesCAVencidoGerenOcup';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues com CA vencido (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalEpisEntreguesCAVencidoOcupacaoGeral(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalEpisEntreguesCAVencidoOcupacaoGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Epis Entregues com CA vencido (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getReuniaoPorMes(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getReuniaoPorMes';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Reuniões por mês!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getReuniaoPorAno(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getReuniaoPorAno';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Reuniões por ano!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalReuniaoPorTipoReuniao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalReuniaoPorTipoReuniao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os Totais de Reuniões por tipo de reunião!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAfastamentosPorCIDLegalOcupacao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAfastamentosPorCIDLegalOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar o total de Afastamentos por CID(Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAfastamentosPorCIDOcupacao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAfastamentosPorCIDOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar o total de Afastamentos por CID (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAfastamentosPorNTEPLegalOcupacao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAfastamentosPorNTEPLegalOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar o total de Afastamentos por NTEP (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getTotalAfastamentosPorNTEPOcupacao(
    dtMesCompetencia?: string,
    dp?: boolean,
  ) {
    const nrOrg = store.getters.user.nrorg;
    const nrestruturam = store.state.estruturaGerencialAtual.NRESTRUTURAM;
    const operador     = store.getters.user.cdoperador

    const route = 'getTotalAfastamentosPorNTEPOcupacao';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
      NRESTRUTURAM    :     nrestruturam,
      CDOPERADOR      :         operador,
      DP              :               dp,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const total: any[] = response.data.dataset.data ?  response.data.dataset.data : null;

      return total;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar o total de Afastamentos por NTEP (Ocupação Geral)!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getComparativoSalarialPorCBO(dp: boolean, dtmesCompetencia?: string) {
    const nrOrg = store.getters.user.nrorg;

    const routeOrg = 'getComparativoSalarialPorCBO';
    const routeGeral = 'getComparativoSalarialPorCBOGeral';
    const routeGeralPorEstadoCbo = 'getComparativoSalarialPorCboMediaEstadualGeral';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtmesCompetencia,
      DP: dp,
    };

    // Gera uma chave única para o cache
    const cacheKey = `comparativo_salarial_${nrOrg}_${dtmesCompetencia}_${dp}`;

    try {
      const forceExpiring = false;
      // Tenta buscar do cache primeiro
      const cachedData = CacheService.getCache(cacheKey,forceExpiring);
      if (cachedData) {
        return cachedData.data;
      }

      // Se não estiver em cache, faz as requisições
      const response = await HttpRequest.get(routeOrg, params);
      const totalOrg: any[] = response.data.dataset.data ? response.data.dataset.data : null;

      const responseGeral = await HttpRequest.get(routeGeral, params);
      const totalGeral: any[] = responseGeral.data.dataset.data ? responseGeral.data.dataset.data : null;

      const responseGeralPorEstadoCbo = await HttpRequest.get(routeGeralPorEstadoCbo, params);
      const mediaGeralPorEstadoCbo: any[] = responseGeralPorEstadoCbo.data.dataset.data ? responseGeralPorEstadoCbo.data.dataset.data : null;

      if(totalOrg && totalGeral && mediaGeralPorEstadoCbo){
        const states = [];
        const statesMap = new Map();

        totalOrg.forEach(item => {
          if (!statesMap.has(item.ESTADO)) {
            statesMap.set(item.ESTADO, true);
            states.push({
              value: item.ESTADO,
              text: item.NMESTADO || item.ESTADO
            });
          }
        });

        const stateData = {};

        const safeNumber = (value: any): number => {
          if (value === null || value === undefined) {
            return 0;
          }

          if (typeof value === 'string') {
            // Remove possíveis caracteres não numéricos, exceto ponto e vírgula
            const cleanValue = value.trim().replace(/[^\d.,]/g, '');
            // Trata diferentes formatos de número
            let num;
            if (cleanValue.includes(',')) {
              num = Number(cleanValue.replace(/\./g, '').replace(',', '.'));
            } else {
              num = Number(cleanValue);
            }
            if (isNaN(num)) {
              return 0;
            }
            return num;
          }
          
          if (typeof value === 'number') {
            if (isNaN(value)) {
              return 0;
            }
            return value;
          }
          const num = Number(value);
          if (isNaN(num)) {
            return 0;
          }
          return num;
        };

        states.forEach(state => {
          const estadoData = totalOrg.filter(item => item.ESTADO === state.value);
          const estadoDataGeral = totalGeral.filter(item => item.ESTADO_GERAL === state.value);
          if (estadoData.length > 0 && estadoDataGeral.length > 0) {
            const primeiroItemEstado = estadoData[0];
            const primeiroItemEstadoGeral = estadoDataGeral[0];

            stateData[state.value] = {
              generalStats: {
                mediaSalarialOrg: safeNumber(primeiroItemEstadoGeral.MEDIA_SALARIO_ORGANIZACAO),
                maiorSalarioOrg: safeNumber(primeiroItemEstadoGeral.MAIOR_SALARIO_ORGANIZACAO),
                menorSalarioOrg: safeNumber(primeiroItemEstadoGeral.MENOR_SALARIO_ORGANIZACAO),
                mediaSalarialGeral: safeNumber(primeiroItemEstadoGeral.MEDIA_SALARIO_GERAL_ESTADO),
                maiorSalarioGeral: safeNumber(primeiroItemEstadoGeral.MAIOR_SALARIO_GERAL_ESTADO),
                menorSalarioGeral: safeNumber(primeiroItemEstadoGeral.MENOR_SALARIO_GERAL_ESTADO),
                diferencaPercentual: 0,
                diferencaPercentualMaiorSalario: 0,
                diferencaPercentualMenorSalario: 0,
                totalCBOs: estadoData.length
              },
              estruturas: []
            };

            if (stateData[state.value].generalStats.mediaSalarialGeral !== 0) {
              stateData[state.value].generalStats.diferencaPercentual = 
                ((stateData[state.value].generalStats.mediaSalarialOrg / 
                  stateData[state.value].generalStats.mediaSalarialGeral - 1) * 100).toFixed(2)
            }

            if (stateData[state.value].generalStats.maiorSalarioGeral !== 0) {
              stateData[state.value].generalStats.diferencaPercentualMaiorSalario = 
                ((stateData[state.value].generalStats.maiorSalarioOrg / 
                  stateData[state.value].generalStats.maiorSalarioGeral - 1) * 100).toFixed(2)
            }

            if (stateData[state.value].generalStats.menorSalarioGeral !== 0) {
              stateData[state.value].generalStats.diferencaPercentualMenorSalario = 
                ((stateData[state.value].generalStats.menorSalarioOrg / 
                  stateData[state.value].generalStats.menorSalarioGeral - 1) * 100).toFixed(2)
            }

            const estruturasMap = new Map();
            estadoData.forEach(item => {
              if (!estruturasMap.has(item.NRESTRUTGEREN)) {
                estruturasMap.set(item.NRESTRUTGEREN, {
                  id: item.NRESTRUTGEREN,
                  nome: item.NMESTRUTURAH,
                  mediaSalarialOrg: safeNumber(item.MEDIA_SALARIO_CBO_GERENCIAL),
                  mediaSalarialGeral: safeNumber(item.MEDIA_SALARIO_GERAL_ESTADO),
                  diferencaPercentual: safeNumber(((safeNumber(item.MEDIA_SALARIO_CBO_GERENCIAL) / 
                                            safeNumber(item.MEDIA_SALARIO_GERAL_ESTADO) - 1) * 100).toFixed(2)),
                  cbos: []
                });
              }

              // Encontra a média salarial do CBO específico para o estado atual
              const mediaCboGeral = mediaGeralPorEstadoCbo.find(media => 
                media.ESTADO_CBO_GERAL === item.ESTADO && 
                media.NRCBO === item.NRCBO
              );

              const mediaSalarialGeralCbo = mediaCboGeral ? 
                safeNumber(mediaCboGeral.MEDIA_SALARIO_CBO_GERAL) : 
                safeNumber(item.MEDIA_SALARIO_GERAL_ESTADO);

              const estrutura = estruturasMap.get(item.NRESTRUTGEREN);
              estrutura.cbos.push({
                codigo: item.NRCBO,
                descricao: item.NMCBO,
                mediaSalarialOrg: safeNumber(item.MEDIA_SALARIO_CBO_GERENCIAL),
                menorSalarioOrg: safeNumber(item.MENOR_SALARIO_CBO_GERENCIAL),
                maiorSalarioOrg: safeNumber(item.MAIOR_SALARIO_CBO_GERENCIAL),
                mediaSalarialGeral: mediaSalarialGeralCbo,
                menorSalarioGeral: safeNumber(item.MENOR_SALARIO_GERAL_ESTADO),
                maiorSalarioGeral: safeNumber(item.MAIOR_SALARIO_GERAL_ESTADO),
                diferencaPercentual: ((safeNumber(item.MEDIA_SALARIO_CBO_GERENCIAL) / 
                                          mediaSalarialGeralCbo - 1) * 100).toFixed(2)
              });
            });

            // Converte o Map de estruturas em array e adiciona ao stateData
            stateData[state.value].estruturas = Array.from(estruturasMap.values());
          }
        });

        const dataMounted: ComparativoSalarial = {
          states,
          stateData
        };

        // Antes de retornar, salva no cache
        CacheService.setCache(cacheKey, dataMounted);
        return dataMounted;
      } else {
        const mockData: ComparativoSalarial = {
          states: [
            { value: 'MG', text: 'Minas Gerais' },
            { value: 'SP', text: 'São Paulo' },
            { value: 'RJ', text: 'Rio de Janeiro' }
          ],
          stateData: {
            'MG': {
              generalStats: {
                mediaSalarialOrg: 5234.89,
                maiorSalarioOrg: 12500.00,
                menorSalarioOrg: 2500.00,
                mediaSalarialGeral: 5500.00,
                maiorSalarioGeral: 13000.00,
                menorSalarioGeral: 2300.00,
                diferencaPercentual: -4.82,
                diferencaPercentualMaiorSalario: 0,
                diferencaPercentualMenorSalario: 0,
                totalCBOs: 45
              },
              estruturas: [
                {
                  id: 1,
                  nome: 'Tecnologia da Informação',
                  mediaSalarialOrg: 8500.00,
                  mediaSalarialGeral: 9200.00,
                  diferencaPercentual: -7.61,
                  cbos: [
                    {
                      codigo: '2124-05',
                      descricao: 'Analista de Desenvolvimento',
                      mediaSalarialOrg: 9200.00,
                      menorSalarioOrg: 7500.00,
                      maiorSalarioOrg: 12500.00,
                      mediaSalarialGeral: 10000.00,
                      menorSalarioGeral: 8000.00,
                      maiorSalarioGeral: 13000.00,
                      diferencaPercentual: -8.00
                    }
                  ]
                }
              ]
            }
          }
        };
        return mockData;
      }
    } catch (err) {
      const errorMessage = 'Não foi possível carregar o Comparativo Salarial!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static clearComparativoSalarialCache(dp: boolean, dtmesCompetencia?: string): void {
    const nrOrg = store.getters.user.nrorg;
    const cacheKey = `comparativo_salarial_${nrOrg}_${dtmesCompetencia}_${dp}`;
    CacheService.clearCache(cacheKey);
  }
}

export default IndicadoresController;
